import { c as _c } from "react/compiler-runtime";
import { useDepartmentStackContext } from "@shared-components/department-stack-provider";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@shared-components/shadcn/table";
import { api } from "@shared-server/api";
interface SummaryTableProps {
  startDate: Date;
  endDate: Date;
}
const prettifyItemName = (itemName: string): string => {
  // Split key on capital letters and separate by space,
  // then lowercase, and capitalize first letter.
  // Example: ChatsWithFilesAttempted -> Chats with files attempted
  if (!itemName) return itemName;
  const lower = itemName.split(/(?=[A-Z])/).join(" ").toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};
export const SummaryTable = props => {
  const $ = _c(49);
  const {
    parentDepartmentId
  } = useDepartmentStackContext();
  let t0;
  if ($[0] !== parentDepartmentId || $[1] !== props.endDate || $[2] !== props.startDate) {
    t0 = {
      startDate: props.startDate,
      endDate: props.endDate,
      parentDepartmentId
    };
    $[0] = parentDepartmentId;
    $[1] = props.endDate;
    $[2] = props.startDate;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const chatsAttempted = api.coreMetrics.chatsAttempted.useQuery(t0);
  let t1;
  if ($[4] !== props.endDate || $[5] !== props.startDate) {
    t1 = {
      startDate: props.startDate,
      endDate: props.endDate
    };
    $[4] = props.endDate;
    $[5] = props.startDate;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const chatsWithFilesAttempted = api.coreMetrics.chatsWithFilesAttempted.useQuery(t1);
  let t2;
  if ($[7] !== parentDepartmentId || $[8] !== props.endDate || $[9] !== props.startDate) {
    t2 = {
      startDate: props.startDate,
      endDate: props.endDate,
      parentDepartmentId
    };
    $[7] = parentDepartmentId;
    $[8] = props.endDate;
    $[9] = props.startDate;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const imagesAttempted = api.coreMetrics.imagesAttempted.useQuery(t2);
  let t3;
  if ($[11] !== props.endDate || $[12] !== props.startDate) {
    t3 = {
      startDate: props.startDate,
      endDate: props.endDate
    };
    $[11] = props.endDate;
    $[12] = props.startDate;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const imagesErrored = api.coreMetrics.imagesErrored.useQuery(t3);
  let t4;
  if ($[14] !== props.endDate || $[15] !== props.startDate) {
    t4 = {
      startDate: props.startDate,
      endDate: props.endDate
    };
    $[14] = props.endDate;
    $[15] = props.startDate;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const translationsFilesAttempted = api.coreMetrics.translationsFilesAttempted.useQuery(t4);
  let t5;
  if ($[17] !== props.endDate || $[18] !== props.startDate) {
    t5 = {
      startDate: props.startDate,
      endDate: props.endDate
    };
    $[17] = props.endDate;
    $[18] = props.startDate;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const translationsTextAttempted = api.coreMetrics.translationsTextAttempted.useQuery(t5);
  const t6 = chatsAttempted.data?.countItems ?? 0;
  const t7 = chatsAttempted.data?.countUsers ?? 0;
  let T0;
  let T1;
  let t10;
  let t8;
  let t9;
  if ($[20] !== chatsWithFilesAttempted.data?.countItems || $[21] !== chatsWithFilesAttempted.data?.countUsers || $[22] !== imagesAttempted.data?.countItems || $[23] !== imagesAttempted.data?.countUsers || $[24] !== imagesErrored.data?.countItems || $[25] !== imagesErrored.data?.countUsers || $[26] !== t6 || $[27] !== t7 || $[28] !== translationsFilesAttempted.data?.countItems || $[29] !== translationsFilesAttempted.data?.countUsers || $[30] !== translationsTextAttempted.data?.countItems || $[31] !== translationsTextAttempted.data?.countUsers) {
    const tableData = {
      chatsAttempted: {
        countItems: t6,
        countUsers: t7
      },
      chatsWithFilesAttempted: {
        countItems: chatsWithFilesAttempted.data?.countItems ?? 0,
        countUsers: chatsWithFilesAttempted.data?.countUsers ?? 0
      },
      imagesAttempted: {
        countItems: imagesAttempted.data?.countItems ?? 0,
        countUsers: imagesAttempted.data?.countUsers ?? 0
      },
      imagesErrored: {
        countItems: imagesErrored.data?.countItems ?? 0,
        countUsers: imagesErrored.data?.countUsers ?? 0
      },
      translationsFilesAttempted: {
        countItems: translationsFilesAttempted.data?.countItems ?? 0,
        countUsers: translationsFilesAttempted.data?.countUsers ?? 0
      },
      translationsTextAttempted: {
        countItems: translationsTextAttempted.data?.countItems ?? 0,
        countUsers: translationsTextAttempted.data?.countUsers ?? 0
      }
    };
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <h2 className="mb-4">{"Summary"}</h2>;
      $[37] = t10;
    } else {
      t10 = $[37];
    }
    T1 = Table;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <TableHeader><TableRow><TableHead>{"Item"}</TableHead><TableHead>{"Count Items Cumulative"}</TableHead><TableHead>{"Count Users Cumulative"}</TableHead></TableRow></TableHeader>;
      $[38] = t9;
    } else {
      t9 = $[38];
    }
    T0 = TableBody;
    t8 = Object.entries(tableData).map(_temp);
    $[20] = chatsWithFilesAttempted.data?.countItems;
    $[21] = chatsWithFilesAttempted.data?.countUsers;
    $[22] = imagesAttempted.data?.countItems;
    $[23] = imagesAttempted.data?.countUsers;
    $[24] = imagesErrored.data?.countItems;
    $[25] = imagesErrored.data?.countUsers;
    $[26] = t6;
    $[27] = t7;
    $[28] = translationsFilesAttempted.data?.countItems;
    $[29] = translationsFilesAttempted.data?.countUsers;
    $[30] = translationsTextAttempted.data?.countItems;
    $[31] = translationsTextAttempted.data?.countUsers;
    $[32] = T0;
    $[33] = T1;
    $[34] = t10;
    $[35] = t8;
    $[36] = t9;
  } else {
    T0 = $[32];
    T1 = $[33];
    t10 = $[34];
    t8 = $[35];
    t9 = $[36];
  }
  let t11;
  if ($[39] !== T0 || $[40] !== t8) {
    t11 = <T0>{t8}</T0>;
    $[39] = T0;
    $[40] = t8;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== T1 || $[43] !== t11 || $[44] !== t9) {
    t12 = <div><T1>{t9}{t11}</T1></div>;
    $[42] = T1;
    $[43] = t11;
    $[44] = t9;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== t10 || $[47] !== t12) {
    t13 = <div>{t10}{t12}</div>;
    $[46] = t10;
    $[47] = t12;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  return t13;
};
function _temp(t0) {
  const [key, value] = t0;
  return <TableRow key={key}><TableCell>{prettifyItemName(key)}</TableCell><TableCell>{value.countItems}</TableCell><TableCell>{value.countUsers}</TableCell></TableRow>;
}